/**
 * @generated SignedSource<<528645e231b67c8445768b0a9d3ec0bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentPlatformContentQueryInput = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  sortBy?: ContentPlatformSortClause | null | undefined;
  where?: ContentPlatformContentClause | null | undefined;
  withFallback?: string | null | undefined;
  withLocales?: ReadonlyArray<string> | null | undefined;
  withProductFeatureFlags?: any | null | undefined;
};
export type ContentPlatformSortClause = {
  fieldNamed?: string;
  havingOrder?: string;
};
export type ContentPlatformContentClause = {
  and?: ReadonlyArray<ContentPlatformContentClause> | null | undefined;
  fieldNamed?: string | null | undefined;
  gte?: ContentPlatformDateCondition | null | undefined;
  hasAnyValue?: boolean | null | undefined;
  havingValues?: ReadonlyArray<string> | null | undefined;
  lte?: ContentPlatformDateCondition | null | undefined;
  or?: ReadonlyArray<ContentPlatformContentClause> | null | undefined;
  searchText?: ContentPlatformSearchTextClause | null | undefined;
};
export type ContentPlatformDateCondition = {
  dateFieldNamed?: string;
  havingDate: any;
};
export type ContentPlatformSearchTextClause = {
  and?: ReadonlyArray<ContentPlatformSearchTextClause> | null | undefined;
  exactlyMatching?: ContentPlatformSearchTextMatchingClause | null | undefined;
  or?: ReadonlyArray<ContentPlatformSearchTextClause> | null | undefined;
  partiallyMatching?: ContentPlatformSearchTextMatchingClause | null | undefined;
};
export type ContentPlatformSearchTextMatchingClause = {
  and?: ReadonlyArray<ContentPlatformSearchTextMatchingClause> | null | undefined;
  fieldNamed?: string | null | undefined;
  havingValues?: ReadonlyArray<string> | null | undefined;
  matchingAllValues?: boolean | null | undefined;
  or?: ReadonlyArray<ContentPlatformSearchTextMatchingClause> | null | undefined;
};
export type confluenceTemplatesUnifiedRelayPageQuery$variables = {
  isSearch?: boolean | null | undefined;
  locale: string;
  partnerTemplatesDataUrlSlugs: ReadonlyArray<string>;
  searchQuery: ContentPlatformContentQueryInput;
};
export type confluenceTemplatesUnifiedRelayPageQuery$data = {
  readonly categories: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly context: any;
      };
    }>;
  };
  readonly collections: {
    readonly " $fragmentSpreads": FragmentRefs<"collectionCardCarouselRelayFragment">;
  };
  readonly partnerTemplates: {
    readonly " $fragmentSpreads": FragmentRefs<"partnerTemplateCardCarouselRelayFragment">;
  };
  readonly preloadedSearchResults?: {
    readonly " $fragmentSpreads": FragmentRefs<"templatePaginatedSearchResultsRelayRefetchableFragment">;
  } | null | undefined;
};
export type confluenceTemplatesUnifiedRelayPageQuery = {
  response: confluenceTemplatesUnifiedRelayPageQuery$data;
  variables: confluenceTemplatesUnifiedRelayPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSearch"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "partnerTemplatesDataUrlSlugs"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v4 = {
  "items": [
    {
      "kind": "Variable",
      "name": "withLocales.0",
      "variableName": "locale"
    }
  ],
  "kind": "ListValue",
  "name": "withLocales"
},
v5 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 50
          },
          (v4/*: any*/)
        ],
        "kind": "ObjectValue",
        "name": "queries"
      }
    ],
    "kind": "ObjectValue",
    "name": "search"
  }
],
v6 = {
  "alias": "categories",
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "forContentType",
      "value": "Template"
    },
    {
      "kind": "Literal",
      "name": "forFields",
      "value": [
        "category"
      ]
    },
    (v4/*: any*/)
  ],
  "concreteType": "ContentPlatformContentFacetConnection",
  "kind": "LinkedField",
  "name": "contentFacet",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformContentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentPlatformContentFacet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "context",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = [
  {
    "fields": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Literal",
                "name": "fieldNamed",
                "value": "urlSlug"
              },
              {
                "kind": "Variable",
                "name": "havingValues",
                "variableName": "partnerTemplatesDataUrlSlugs"
              }
            ],
            "kind": "ObjectValue",
            "name": "where"
          },
          (v4/*: any*/)
        ],
        "kind": "ObjectValue",
        "name": "queries"
      }
    ],
    "kind": "ObjectValue",
    "name": "search"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateId",
  "storageKey": null
},
v12 = [
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "confluenceTemplatesUnifiedRelayPageQuery",
    "selections": [
      {
        "alias": "collections",
        "args": (v5/*: any*/),
        "concreteType": "ContentPlatformTemplateCollectionContentSearchConnection",
        "kind": "LinkedField",
        "name": "templateCollections",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "collectionCardCarouselRelayFragment"
          }
        ],
        "storageKey": null
      },
      (v6/*: any*/),
      {
        "alias": "partnerTemplates",
        "args": (v7/*: any*/),
        "concreteType": "ContentPlatformTemplateContentSearchConnection",
        "kind": "LinkedField",
        "name": "templates",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "partnerTemplateCardCarouselRelayFragment"
          }
        ],
        "storageKey": null
      },
      {
        "condition": "isSearch",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "searchQuery",
                      "variableName": "searchQuery"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "templatePaginatedSearchResultsRelayRefetchableFragment"
                }
              ],
              "type": "Query",
              "abstractKey": null
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "preloadedSearchResults"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "confluenceTemplatesUnifiedRelayPageQuery",
    "selections": [
      {
        "alias": "collections",
        "args": (v5/*: any*/),
        "concreteType": "ContentPlatformTemplateCollectionContentSearchConnection",
        "kind": "LinkedField",
        "name": "templateCollections",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateCollectionResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformTemplateCollection",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "collectionId",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateImageAsset",
                    "kind": "LinkedField",
                    "name": "collectionIcon",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateCollectionGuide",
                    "kind": "LinkedField",
                    "name": "howToUseThisCollection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentPlatformTemplateCollectionStep",
                        "kind": "LinkedField",
                        "name": "collectionSteps",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v6/*: any*/),
      {
        "alias": "partnerTemplates",
        "args": (v7/*: any*/),
        "concreteType": "ContentPlatformTemplateContentSearchConnection",
        "kind": "LinkedField",
        "name": "templates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "oneLinerHeadline",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "condition": "isSearch",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  {
                    "items": [
                      {
                        "kind": "Variable",
                        "name": "queries.0",
                        "variableName": "searchQuery"
                      }
                    ],
                    "kind": "ListValue",
                    "name": "queries"
                  }
                ],
                "kind": "ObjectValue",
                "name": "search"
              }
            ],
            "concreteType": "ContentPlatformTemplateContentSearchConnection",
            "kind": "LinkedField",
            "name": "templates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformTemplateResultEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pluginModuleKey",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "previewBlurb",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentPlatformTaxonomyTemplateType",
                        "kind": "LinkedField",
                        "name": "templateType",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "templateTypeName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "contributor",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v12/*: any*/),
                            "type": "ContentPlatformOrganization",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentPlatformOrganization",
                                "kind": "LinkedField",
                                "name": "organization",
                                "plural": false,
                                "selections": (v12/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "ContentPlatformAuthor",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e7fabbe0409d86a7c3e04d6e63107259",
    "id": null,
    "metadata": {},
    "name": "confluenceTemplatesUnifiedRelayPageQuery",
    "operationKind": "query",
    "text": "query confluenceTemplatesUnifiedRelayPageQuery(\n  $locale: String!\n  $partnerTemplatesDataUrlSlugs: [String!]!\n  $searchQuery: ContentPlatformContentQueryInput!\n  $isSearch: Boolean = false\n) {\n  collections: templateCollections(search: {queries: {first: 50, withLocales: [$locale]}}) {\n    ...collectionCardCarouselRelayFragment\n  }\n  categories: contentFacet(first: 25, forFields: [\"category\"], forContentType: \"Template\", withLocales: [$locale]) {\n    edges {\n      node {\n        context\n      }\n    }\n  }\n  partnerTemplates: templates(search: {queries: {withLocales: [$locale], where: {fieldNamed: \"urlSlug\", havingValues: $partnerTemplatesDataUrlSlugs}}}) {\n    ...partnerTemplateCardCarouselRelayFragment\n  }\n  ...templatePaginatedSearchResultsRelayRefetchableFragment_2rw059 @skip(if: $isSearch)\n}\n\nfragment collectionCardCarouselRelayFragment on ContentPlatformTemplateCollectionContentSearchConnection {\n  edges {\n    node {\n      collectionId\n      ...collectionCardRelayFragment\n    }\n  }\n}\n\nfragment collectionCardRelayFragment on ContentPlatformTemplateCollection {\n  collectionId\n  name\n  urlSlug\n  collectionIcon {\n    url\n  }\n  howToUseThisCollection {\n    collectionSteps {\n      __typename\n    }\n  }\n}\n\nfragment partnerTemplateCardCarouselRelayFragment on ContentPlatformTemplateContentSearchConnection {\n  edges {\n    node {\n      templateId\n      urlSlug\n      ...partnerTemplateCardRelayFragment\n    }\n  }\n}\n\nfragment partnerTemplateCardRelayFragment on ContentPlatformTemplate {\n  templateId\n  urlSlug\n  name\n  oneLinerHeadline\n}\n\nfragment templateCardRelayFragment on ContentPlatformTemplate {\n  templateId\n  name\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateType {\n    id\n    templateTypeName\n  }\n  contributor {\n    __typename\n    ... on ContentPlatformOrganization {\n      name\n    }\n    ... on ContentPlatformAuthor {\n      organization {\n        name\n      }\n    }\n  }\n}\n\nfragment templatePaginatedSearchResultsRelayRefetchableFragment_2rw059 on Query {\n  templates(search: {queries: [$searchQuery]}) {\n    edges {\n      node {\n        templateId\n        name\n        urlSlug\n        ...templateCardRelayFragment\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8cdd9c804945fbd78aa3c9fb81ac86b1";

export default node;
